'use strict';

import React, { Component, Fragment } from 'react';
import MultiSelect from 'Components/Forms/Elements/MultiSelect';
import FileInput from 'Components/Forms/Elements/FileInput';
import TextInput from 'Components/Forms/Elements/TextInput';
import Select from 'Components/Forms/Elements/Select';
import Switch from 'Components/Forms/Elements/Switch';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getStateFromObject from 'Components/Forms/Functions/getStateFromObject';
import handleFileChange from 'Components/Forms/Functions/handleFileChange';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import handleChange from 'Components/Forms/Functions/handleChange';
import getFormData from 'Components/Forms/Functions/getFormData';
import bemit from 'Functions/bemit';
import Loader from 'Pure/Loader';
import { service_categories as category_options, coworking_place_types } from 'Shared/options';
import { action } from 'Shared/Routes';
import { isTrue } from 'Shared/utilities';
const {
  app,
  qwest
} = window;
const types = coworking_place_types.map(opt => ({
  label: opt.front_short_label,
  value: opt.new_value
}));
const default_state = {
  'servicetitle[title]': '',
  'servicetitle[types]': [],
  'servicetitle[category]': ''
};
export default class ServiceTitleForm extends Component {
  state = {
    status_messages: {},
    ...default_state
  };
  handleFileChange = handleFileChange.bind(this);
  handleChange = handleChange.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.type === 'update') {
      component.fetchServiceTitle();
    }
  }
  fetchServiceTitle = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('getAllServiceTitles'), {
      id: props.id || document.location.pathname.split('/liste-des-titres-de-service/')[1],
      with_count: false
    }).then(function (xhr, response) {
      const servicetitle = response.data[0] || {};
      const types = (servicetitle.types || []).slice(0);
      delete servicetitle.types;
      const default_img = (servicetitle.default_img || []).map(image => ({
        ...image,
        status: 'uploaded'
      }));
      delete servicetitle.default_img;
      const update = getStateFromObject({
        data: servicetitle,
        model: 'servicetitle'
      });
      component.setState({
        ...update,
        'servicetitle[types]': types,
        'servicetitle[default_img]': default_img,
        '__files-servicetitle[default_img]': default_img,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
    component.setState({});
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const servicetitle = getFormData({
      state: state,
      pattern: 'servicetitle['
    });
    const url = props.type === 'update' ? '/servicetitle/update' : '/servicetitle/create';
    qwest.post(url, servicetitle).then(function (xhr, response) {
      if (props.type === 'update') {
        component.fetchServiceTitle();
      } else {
        component.clearForm();
        window.setTimeout(function () {
          app.navigateTo('/liste-des-titres-de-service');
        }, 2000);
      }
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  clearForm = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState(default_state);
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = getFormStatus(state);
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let output = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("form", {
      method: "POST",
      action: "/servicetitle/create",
      className: props.paper !== false ? 'c-paper' : undefined
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['servicetitle[title]'],
      name: "servicetitle[title]",
      label: "Titre",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(MultiSelect, {
      options: types,
      onChange: component.handleChange,
      value: state['servicetitle[types]'],
      name: "servicetitle[types]",
      label: "Types d'espace",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(Select, {
      options: category_options,
      onChange: component.handleChange,
      value: state['servicetitle[category]'],
      name: "servicetitle[category]",
      type: "text",
      label: "Cat\xE9gorie",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: component.handleChange,
      value: isTrue(state["servicetitle[with_stock]"]),
      name: "servicetitle[with_stock]",
      "top-label": "Allocation de places",
      label: "Oui",
      "left-label": "Non",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: component.handleChange,
      value: isTrue(state["servicetitle[with_range]"]),
      name: "servicetitle[with_range]",
      "top-label": "R\xE9servable selon une plage horaire",
      label: "Oui",
      "left-label": "Non",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(FileInput, {
      accept: ".jpg,.jpeg,.png,.gif,.svg",
      onChange: component.handleFileChange,
      name: "servicetitle[default_img]",
      data: state,
      multiple: false,
      status: state.status_messages,
      label: "Image de fond par d\xE9faut"
    }))), status), /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-text-center\r u-margin-top-25 u-padding-bottom-20 "
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: component.validate
    }, props.type === 'update' ? 'Mettre à jour' : 'Créer ce titre', loader)));
    return output;
  }
}
